import LyLog from './src/index.vue'

LyLog.install = function (Vue) {
    Vue.component(LyLog.name, LyLog)
}

export default LyLog



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/log/index.js
// module id = null
// module chunks = 